import React from 'react';

const StationDetailsPage = () => {
  return (
    <div>
      <h2>Station Details Page</h2>
      <p>This page will contain station details.</p>
    </div>
  );
};

export default StationDetailsPage; 
